






























export default {
  props: {
    header: {
      default: '',
      type: String,
    },
    body: {
      default: '',
      type: String,
    },
    okText: {
      default: 'Ok',
      type: String,
    },
    cancelText: {
      default: 'Cancel',
      type: String,
    },
    onOk: {
      default: () => {},
      type: Function,
    },
    onCancel: {
      default: () => {},
      type: Function,
    },
    okBtnClass: {
      default: '',
      type: String,
    },
  },
};
